import { Button, Col, Image, Input, Modal, Radio, Row, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import {
    SaveOutlined, // اضافه شد برای رفع خطای "is not defined"
    RollbackOutlined, 
    CheckOutlined, 
    UploadOutlined
} from '@ant-design/icons';
import { SetPaymentByFish_Reserve_Api } from '../../API/ReserveApi';

// -----------------------------------------------------------
import DateObject from "react-date-object";
// وارد کردن DatePicker و تنظیمات شمسی
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// -----------------------------------------------------------

// =================================================================
const SERVER_DATE_FORMAT = "YYYY-MM-DD";

/**
 * تابع کمکی برای تبدیل ارقام فارسی/عربی به انگلیسی و تبدیل اسلش به خط تیره.
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    let output = String(str).trim();

    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    return output.replace(/\//g, "-");
};

// =================================================================
/**
 * آداپتور سفارشی PersianDatePickerAdapter برای فیلد تاریخ واریز
 */
const PersianDatePickerAdapter = ({ value, onChange, placeholder }) => {
  let initialValue = null;
  if (value) {
    const parts = persianToEnglishNumbers(value).split('-');
    if (parts.length === 3) {
      try {
        initialValue = new DateObject({
          calendar: persian,
          locale: persian_fa,
          year: parseInt(parts[0], 10),
          month: parseInt(parts[1], 10),
          day: parseInt(parts[2], 10),
        });
      } catch (e) {
        console.error("Error creating initial Persian date:", e);
        initialValue = null;
      }
    }
  }

     const handleOnChange = (dateObject) => {
    let dateString = null;
    if (dateObject && !Array.isArray(dateObject)) {
      dateString = persianToEnglishNumbers(dateObject.format(SERVER_DATE_FORMAT));
    }
    onChange(dateString);
  };

   return (
    <DatePicker
      calendar={persian}
      locale={persian_fa}
      value={initialValue}
      onChange={handleOnChange}
      inputClass="ant-input persian-date-input"
      calendarPosition="bottom-right"
      format={SERVER_DATE_FORMAT}
      placeholder={placeholder}
    />
  );
};
// =================================================================

export const PaymentComponent = ({
    setLoading,
    showMessage,
    reserve,
    period,
    version,
    setVersion
}) => {
    // =================================================================
    const [selectedPeymentType, setSelectedPaymentType] = useState(1);

    const [fishCode, setFishCode] = useState("");
    const [paymentDate, setPaymentDate] = useState(null); // تاریخ به فرمت YYYY-MM-DD
    const [file, setFile] = useState(null);
    const [currentFileList, setCurrentFileList] = useState([]);


    // =================================================================
    useEffect(() => {
        loadData();
    }, [version]);
    // =================================================================
    const loadData = () => {
        let defaultPaymentType = 1;
        if (period.enableElectronicPay) {
            defaultPaymentType = 1;
        } else if (period.enablePayByFish) {
            defaultPaymentType = 2;
        }

        if (reserve.paymentType === "PayByFish") {
            defaultPaymentType = 2;
        }
        
        setSelectedPaymentType(defaultPaymentType);
        setFishCode(reserve.fishCode || "");
        
        // تنظیم تاریخ واریز از اطلاعات رزرو، با تبدیل ارقام فارسی به انگلیسی برای DatePicker
        const shamsiDate = reserve.paymentDate_Shamsi ? persianToEnglishNumbers(reserve.paymentDate_Shamsi) : null;
        setPaymentDate(shamsiDate);
        
        // تنظیم لیست فایل فعلی برای نمایش فایل قبلی
        if (reserve.fishFileURL) {
            setCurrentFileList([{
                uid: '-1',
                name: 'فیش واریزی موجود',
                status: 'done',
                url: reserve.fishFileURL,
            }]);
        } else {
            setCurrentFileList([]);
        }
        setFile(null); // در بارگذاری مجدد فایل جدید را ریست می کنیم
    }
    // =================================================================
    const onPayTypeChange = (e) => {
        setSelectedPaymentType(e.target.value);
    };
    // =================================================================
    const handleFileChange = (info) => {
        // برای نمایش فقط یک فایل جدید
        let newFileList = [...info.fileList];
        newFileList = newFileList.slice(-1); 

        // اگر فایل جدیدی انتخاب شده باشد
        if (newFileList.length > 0) {
            setFile(newFileList[0].originFileObj);
            // اطمینان از نمایش فایل در لیست آپلود
            setCurrentFileList(newFileList.map(f => ({ ...f, status: 'done', name: f.name })));
        } else {
            setFile(null);
            // اگر فایل حذف شود و فایل قبلی در سرور موجود باشد، آن را دوباره در لیست قرار می‌دهیم.
            setCurrentFileList(reserve.fishFileURL ? [{ uid: '-1', name: 'فیش واریزی موجود', status: 'done', url: reserve.fishFileURL }] : []);
        }
    };
    // فرض: import DateObject from "react-date-object"; و دیگر import ها بالای فایل هست.  
const shamsiStringToJSDate = (shamsiStr) => {  
  if (!shamsiStr) return null;  
  const parts = persianToEnglishNumbers(shamsiStr).split("-");  
  if (parts.length !== 3) return null;  
  const y = parseInt(parts[0], 10);  
  const m = parseInt(parts[1], 10);  
  const d = parseInt(parts[2], 10);  
  try {  
    const sh = new DateObject({ calendar: persian, locale: persian_fa, year: y, month: m, day: d });  
    return sh.toDate();  
  } catch (e) {  
    // fallback: if toDate not available, use JS Date from components (month-1)  
    try {  
      return new Date(y, m - 1, d);  
    } catch (e2) {  
      return null;  
    }  
  }  
};
    // =================================================================
    const onSubmitFish = async () => {
        try {
            if (!paymentDate) {
                showMessage("یک تاریخ واریز معتبر وارد کنید.", "error");
                return;
            }

const paymentJSDate = shamsiStringToJSDate(paymentDate);  
    if (!paymentJSDate) {  
      showMessage("تاریخ وارد شده معتبر نیست.", "error");  
      return;  
    }  

    // امروز بدون زمان  
    const now = new Date();  
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());  

    // شرط 1: تاریخ فیش نباید بعد از امروز باشد  
    const paymentNoTime = new Date(paymentJSDate.getFullYear(), paymentJSDate.getMonth(), paymentJSDate.getDate());  
    if (paymentNoTime > today) {  
      showMessage("تاریخ واریز نمی‌تواند بعد از امروز باشد.", "error");  
      return;  
    }  

    // بررسی تاریخ شروع رزرو  
    // const reserveFromRaw = reserve.From; // فرض: reserve.From یک ISO string یا Date است  
    // const reserveFrom = reserveFromRaw  
    //   ? (reserveFromRaw instanceof Date ? reserveFromRaw : new Date(reserveFromRaw))  
    //   : null;  

    // if (!reserveFrom || isNaN(reserveFrom.getTime())) {  
    //   showMessage("تاریخ شروع رزرو نامعتبر است.", "error");  
    //   return;  
    // }  

    // // نرمال‌سازی بدون زمان  
    // const reserveFromNoTime = new Date(reserveFrom.getFullYear(), reserveFrom.getMonth(), reserveFrom.getDate());  

    // // شرط جدید: اگر امروز سه روز یا بیشتر بعد از تاریخ شروع رزرو باشد => رد کن  
    // const diffMsTodayReserve = today - reserveFromNoTime;  
    // const diffDaysTodayReserve = Math.floor(diffMsTodayReserve / (1000 * 60 * 60 * 24)); // تعداد روز کامل  

    // if (diffDaysTodayReserve >= 3) {  
    //   showMessage("امکان ثبت فیش وجود ندارد؛ از تاریخ شروع اقامت ۳ روز یا بیشتر گذشته است.", "error");  
    //   return;  
    // }  




            // اگر فایلی جدید انتخاب نشده و فایل قبلی هم وجود ندارد
            if (!file && !reserve.fishFileURL) {
                showMessage("تصویر فیش واریزی را انتخاب کنید.", "error");
                return;
            }

            if (!fishCode) {
                showMessage("شماره فیش معتبر وارد کنید.", "error");
                return;
            }

            setLoading(true);
            //////////////////////////////
            const formData = new FormData();
            
            if (file) {
                formData.append("photo", file);
            }

            formData.append("reserveId", reserve.id);
            formData.append("paymentDate", paymentDate);
            formData.append("fishCode", fishCode);

            let data = await SetPaymentByFish_Reserve_Api(formData);
            
            if (data.messageStatus === "Successful") {
                showMessage(data.message, "Successful");
                setVersion(version + 1); // برای بارگذاری مجدد اطلاعات
            }
            else {
                showMessage(data.message, "error");
            }
        }
        catch (error) {
            showMessage("خطا در ارتباط با سرور", "error");
        }
        finally {
            setLoading(false);
        }
    };
    // =================================================================
    return (
        <div>
            <div className='container'>
                <Radio.Group onChange={onPayTypeChange} value={selectedPeymentType} style={{ width: '100%' }}>
                    <Row justify='center' style={{ paddingTop: '8px', paddingBottom: '8px' }}>

                        {period.enableElectronicPay ?
                            <Col xs={12} sm={12} md={12} lg={6} xl={6} >
                                <Radio value={1}>پرداخت الکترونیک</Radio>
                            </Col> : <></>}

                        {period.enablePayByFish ?
                            <Col xs={12} sm={12} md={12} lg={6} xl={6} >
                                <Radio value={2}> ثبت فیش واریزی</Radio>
                            </Col> : <></>}
                    </Row>
                </Radio.Group>
            </div>

            {selectedPeymentType === 1 ?
                <div className='container'>
                    {/* محتوای پرداخت الکترونیک - دکمه هدایت به درگاه */}
                    <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
                        برای ادامه فرآیند پرداخت، لطفاً دکمه "پرداخت الکترونیک" را فشار دهید.
                    </p>
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <Button 
                            type="primary" 
                            size="large"
                            // onClick={...} // در اینجا باید تابع هدایت به درگاه پرداخت قرار گیرد
                        >
                            <SaveOutlined />
                            پرداخت الکترونیک
                        </Button>
                    </div>
                </div> : <></>
            }

            {selectedPeymentType === 2 ?
                <>
                    <div className='container'>
                        <Row gutter={[16, 16]}>
                            <Col xs={12} sm={12} md={5} lg={3} xl={3} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                                قابل پرداخت (ریال):
                            </Col>

                            <Col xs={12} sm={12} md={6} lg={4} xl={4} className='valueColumn'>
                                <Input 
                                    placeholder='' 
                                    value={reserve.factor?.payablPrice ? reserve.factor.payablPrice.toLocaleString('fa-IR') : '0'} 
                                    readOnly 
                                    style={{ textAlign: 'right' }} 
                                />
                            </Col>

                            <Col xs={0} sm={0} md={2} lg={1} xl={1} />

                            <Col xs={12} sm={12} md={5} lg={2} xl={2} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                                شماره فیش:
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={3} xl={3} className='valueColumn'>
                                <Input 
                                    placeholder='شماره فیش' 
                                    value={fishCode} 
                                    onChange={(e) => { setFishCode(e.target.value) }} 
                                    style={{ textAlign: 'right' }} 
                                />
                            </Col>

                            <Col xs={0} sm={0} md={0} lg={1} xl={1} />

                            <Col xs={12} sm={12} md={5} lg={2} xl={2} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
                                تاریخ واریز:
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={3} xl={3} className='valueColumn'>
                                <PersianDatePickerAdapter 
                                    value={paymentDate} 
                                    placeholder="تاریخ واریز" 
                                    onChange={setPaymentDate} 
                                />
                            </Col>

                            <Col xs={0} sm={0} md={2} lg={1} xl={1} />

                            <Col xs={24} sm={24} md={11} lg={3} xl={3} className='valueColumn'>
                                <Upload
                                    beforeUpload={() => false}
                                    onChange={handleFileChange}
                                    accept="image/*"
                                    maxCount={1}
                                    fileList={currentFileList}
                                    onRemove={(file) => { 
                                        setFile(null); 
                                        setCurrentFileList(file.uid === '-1' && reserve.fishFileURL 
                                            ? [] 
                                            : reserve.fishFileURL 
                                                ? [{ uid: '-1', name: 'فیش واریزی موجود', status: 'done', url: reserve.fishFileURL }] 
                                                : []
                                        );
                                        return true; 
                                    }}
                                >
                                    <Button icon={<UploadOutlined />} style={{ width: '100%' }}> تصویر فیش واریزی</Button>
                                </Upload>
                            </Col>

                            <Col span={24} style={{ marginTop: '20px', textAlign: 'center' }}>
                                {reserve.fishFileURL && (
                                    <Image
                                        style={{ border: '2px solid #cdcdcd', borderRadius: '10px', maxWidth: '300px', maxHeight: '300px' }}
                                        src={reserve.fishFileURL} 
                                        alt="تصویر فیش واریزی قبلی"
                                    />
                                )}
                            </Col>
                        </Row>
                    </div>

                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={16} lg={18} xl={18} />
                        <Col xs={24} sm={24} md={8} lg={6} xl={6} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="button" 
                                onClick={() => {
                                    Modal.confirm({
                                        title: 'آیا از صحت اطلاعات اطمینان دارید؟',
                                        onOk: () => { onSubmitFish() },
                                        footer: (_, { OkBtn, CancelBtn }) => (
                                            <>
                                                <CancelBtn />
                                                <OkBtn />
                                            </>
                                        ),
                                    });
                                }}
                            >
                                <CheckOutlined />
                                ثبت فیش
                            </Button>
                        </Col>
                    </Row>

                </> : <></>
            }
        </div>
    )
}